import { useCrossDeviceRecovery } from "../../hooks/useCrossDeviceRecovery";

// HEADLESS as of 2026-07-30 — this component renders nothing and exists only to
// mount the silent recovery poll.
//
// It used to paint the cross-device recovery banner: the legacy row ("A recording
// from 2:14 PM is still on your other device. Open that device to finish saving
// it.") and Path B's "Recover anyway?" nudge for an incomplete web recording. Both
// rows were removed at Joshua's request. The trigger was the phone case: dictate on
// the phone, open the desktop later, and the banner is there — and for a NATIVE
// recording it was built to never quiet (the old poll exempted native rows from both
// the zero-segment filter and the ~24h NAG_MAX_AGE_MS bound, on the reasoning that
// phone-only audio has no server copy to fall back on). Correct in intent, but it
// made the bar permanent furniture on the desktop rather than an actionable prompt.
//
// WHAT SURVIVES, deliberately: the silent half of cross-device recovery. The hook
// below keeps polling for a WEB recording stranded on another device and pulls,
// stitches, and re-attaches it in the background with no UI at all. Unmounting this
// component from Layout.js would have killed that too — which is why the component
// stays mounted instead of being deleted.
//
// WHAT IS GONE, stated plainly so nobody assumes otherwise:
//   - Nothing surfaces an INCOMPLETE recording any more. Path B auto-attaches only a
//     recording it can PROVE is complete (recordingCompleteness.isProvablyComplete);
//     an incomplete one used to be offered as an explicit "Recover anyway?" consent
//     nudge and now simply is not offered.
//   - A NATIVE (phone) recording whose audio never reached the server has no prompt
//     at all. Nothing on the desktop can recover it — only finishing the upload on
//     the phone itself, or the backend retention sweep, will touch it.
//
// The bar's own 60s poll went with the rows: it was a second `Recording - Pending
// List` call plus a per-encounter api.getChat to name the patient on each row, and
// both existed only to render. useCrossDeviceRecovery runs its own poll on the same
// cadence for the silent path, so nothing is lost. Dropping that api.getChat is why
// the matching "RecordingRecoveryBar#api.getChat#1" entry was removed from
// src/utils/encounterWriteRegistry.js — that registry's CI scanner fails the build
// when a listed call site no longer exists.
const RecordingRecoveryBar = () => {
  // Called for its EFFECTS only. The hook self-gates on the encounters feature, the
  // ff_recordingAutoRecover kill-switch, and the native/demo environment skip
  // (useCrossDeviceRecovery.js:159-200), so no gate is needed here. Its return value
  // (nudgeCandidate / recoverNudge / dismissNudge / recoveringIds) drove the removed
  // rows and is intentionally ignored.
  useCrossDeviceRecovery();
  return null;
};

export default RecordingRecoveryBar;
